<template>
  <transition
    enter-active-class="duration-75 ease-out"
    enter-class="opacity-0"
    enter-to-class="opacity-100"
    leave-active-class="duration-200 ease-in"
    leave-class="opacity-100"
    leave-to-class="opacity-0"
    @after-enter="$emit('show-modal')"
  >
    <div
      v-bsl="true"
      v-if="displayShade"
      class="fixed top-0 left-0 z-50 flex items-center justify-center w-screen h-screen p-6"
    >
      <!-- Shade -->
      <div
        class="fixed inset-0 transition-opacity bg-gray-500 opacity-75"
        @click="handleClose"
      />
      <!-- Modal -->
      <transition
        enter-active-class="duration-300 ease-out"
        enter-class="translate-y-4 opacity-0 sm:translate-y-0 sm:scale-95"
        enter-to-class="translate-y-0 opacity-100 sm:scale-100"
        leave-active-class="duration-200 ease-in"
        leave-class="translate-y-0 opacity-100 sm:scale-100"
        leave-to-class="translate-y-4 opacity-0 sm:translate-y-0 sm:scale-95"
      >
        <div
          v-show="displayModal"
          class="px-5 pt-5 pb-4 overflow-hidden transition-all transform bg-white rounded-lg shadow-xl sm:max-w-lg sm:w-full sm:p-6 z-1000"
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal-headline"
        >
          <div v-show="allowClose" class="flex justify-end pb-3">
            <button @click="handleClose">
              <svg viewBox="0 0 20 20" fill="#bbb" class="w-6 h-6">
                <path
                  fill-rule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clip-rule="evenodd"
                />
              </svg>
            </button>
          </div>
          <slot />
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Modal',
  components: {},
  mixins: [],
  props: {
    displayShade: {
      type: Boolean,
      required: true
    },
    displayModal: {
      type: Boolean,
      required: true
    },
    allowClose: {
      type: Boolean,
      default: true
    },
    rerouteOnClose: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {}
  },
  computed: {},
  watch: {},

  // Lifecycle Hooks
  beforeCreate () {},
  created () {},
  beforeMount () {},
  mounted () {},
  beforeUpdate () {},
  updated () {},
  beforeDestroy () {},
  destroyed () {},
  methods: {
    handleClose () {
      if (this.allowClose && !this.rerouteOnClose) this.$emit('hide-all')
      else this.$router.push({ path: '/' })
    }
  }
}
</script>

<style scoped>
</style>
